<template>
  <div class="customer-invite-list">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="mb-0">{{$t('customer_invites.title')}}</h2>
      <b-button variant="primary" @click="createCustomerInvite">
        <i class="fas fa-plus mr-2"></i>{{$t('customer_invites.invite_button')}}
      </b-button>
    </div>

    <CrudTable
      :columns="fields"
      :data-sources="customerInvites"
      :pagination="paginationInfo"
      :loader="isLoading"
      list-url="/admin/customer-invites"
      @search="handleSearch"
      @filter="handleFilter"
      @refresh="fetchCustomerInvites"
    >
      <!-- Status Column -->
      <template #cell(invitation_status)="data">
        <div>
          {{$t('customer_invites.status.' + (data.item.invitation_status || 'pending'))}}
        </div>
      </template>

      <!-- Sender Column -->
      <template #cell(sender)="data">
        <div>
          {{ data.item.sender?.name || 'N/A' }}
        </div>
      </template>

    </CrudTable>

  </div>
</template>

<script>
import { request } from "@/Util/Request";
import CrudTable from "@/components/CrudTable.vue";

export default {
  name: 'CustomerInviteList',
  components: {
    CrudTable
  },

  data() {
    return {
      customerInvites: [],
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      sortBy: 'created_at',
      sortDesc: true,

      filters: {
        search: '',
        status: null
      },
      fields: [
        { key: 'phone', label: this.$t('customer_invites.table_header_phone'), sortable: true, sortDirection: 'asc' },
        { key: 'invitation_status', label: this.$t('customer_invites.table_header_status'), sortable: true, sortDirection: 'asc' },
        { key: 'sender', label: this.$t('customer_invites.table_header_invited_by'), sortable: true, sortDirection: 'asc' },
        { key: 'expires_at', label: this.$t('customer_invites.table_header_expires_at'), sortable: true, sortDirection: 'asc' },
      ],
      statusOptions: [
        { value: null, text: this.$t('customer_invites.status_all') || 'All Status' },
        { value: 'pending', text: this.$t('customer_invites.status.pending') },
        { value: 'accepted', text: this.$t('customer_invites.status.accepted') },
        { value: 'rejected', text: this.$t('customer_invites.status.rejected') },
        { value: 'expired', text: this.$t('customer_invites.status.expired') }
      ],
      paginationInfo: {
        from: 0,
        to: 0,
        total: 0
      }
    }
  },
  methods: {
    handleSearch(search) {
      this.filters.search = search;
      this.currentPage = 1;
      this.fetchCustomerInvites();
    },
    handleFilter(filter) {
      this.filters = { ...this.filters, ...filter };
      this.currentPage = 1;
      this.fetchCustomerInvites();
    },
    createCustomerInvite() {
      this.$router.push('/admin/customer-invites/create');
    },
    async fetchCustomerInvites() {
      this.isLoading = true;
      try {
        const response = await request({
          method: "get",
          url: '/admin/customer-invites',
          params: {
            page: this.currentPage,
            per_page: this.perPage,
            sort_by: this.sortBy,
            sort_desc: this.sortDesc,
            search: this.filters.search,
            status: this.filters.status
          }
        });

        if (response.status === 200) {
          this.customerInvites = response.data.data;
          this.paginationInfo = {
            from: response.data.from,
            to: response.data.to,
            total: response.data.total
          };
        }
      } catch (error) {
        console.error('Error fetching customer invites:', error);
        this.$bvToast.toast('Error loading customer invitations', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.isLoading = false;
      }
    },
    getStatusVariant(status) {
      switch (status) {
        case 'pending':
          return 'warning';
        case 'accepted':
          return 'success';
        case 'rejected':
          return 'danger';
        case 'expired':
          return 'secondary';
        default:
          return 'info';
      }
    }
  }
}
</script>

<style scoped>
.customer-invite-list {
  padding: 20px;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>
